import { Flex } from '@chakra-ui/react';
import {
  MainFilter,
  SearchFilter,
  SortByFilter,
  TableCardToggle,
} from './components';
import { FilterContainer } from '@/components/filters_revamp';

export const Filter = ({
  configs = [],
  activeFilters,
  isSortEnabled = false,
  sortOptions = [],
  sort = {},
  isSearchEnabled = false,
  hideSearchFullView = false,
  rightAdditionalContent = null,
  searchTerm = '',
  enableToggleView = false,
  toggleList = undefined,
  currentView = undefined,
  filterActions,
  mainFilterProps = {},
  CustomFilters = () => <></>,
  RightCustomFilters = () => <></>,
  onSave: _onSave = () => {},
  selected = [],
  filtersToShow = [],
  customFilters = [],
  isNewFilter = false,
  filterConfig = {},
  accordionTitle = undefined,
  newFilterStyles = false,
  showAccordion = true,
  showSearchInput = true,
  searchProps = {},
  disabled = false,
  sortMenuItemStyles = {},
  filterContainerProps = {},
}) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="baseline"
      gap="8px"
      data-test-id="filters-container"
    >
      <Flex
        alignItems="center"
        alignSelf="center"
        {...filterContainerProps}
        data-test-id="filters-left-container"
      >
        {isNewFilter ? (
          <FilterContainer
            filterActions={filterActions}
            selected={selected}
            filtersToShow={filtersToShow}
            customFilters={customFilters}
            filterConfig={filterConfig}
            accordionTitle={accordionTitle}
            showAccordion={showAccordion}
            showSearchInput={showSearchInput}
            newFilterStyles={newFilterStyles}
            disabled={disabled}
          />
        ) : (
          <MainFilter
            mainFilterProps={mainFilterProps}
            configs={configs}
            filterActions={filterActions}
            activeFilters={activeFilters}
          />
        )}

        <CustomFilters />
      </Flex>
      <Flex
        alignItems="center"
        gap=".5rem"
        minW="fit-content"
        data-test-id="filters-right-container"
      >
        <RightCustomFilters />
        {isSortEnabled && (
          <SortByFilter
            sort={sort}
            options={sortOptions}
            filterActions={filterActions}
            menuItemStyles={sortMenuItemStyles}
          />
        )}
        {rightAdditionalContent}
        {enableToggleView && (
          <TableCardToggle
            toggleList={toggleList}
            currentView={currentView}
            filterActions={filterActions}
          />
        )}
        {isSearchEnabled && (
          <SearchFilter
            filterActions={filterActions}
            searchTerm={searchTerm}
            hideSearchFullView={hideSearchFullView}
            inputGroupStyles={searchProps.inputGroupStyles}
            placeholder={searchProps.placeholder}
          />
        )}
      </Flex>
    </Flex>
  );
};
